import React from "react";
import { Box, Typography, Chip } from "@mui/material";

interface MobileNoticeProps {
  page: string;
}

const MobileNotice: React.FC<MobileNoticeProps> = ({ page }) => (
  <Box
    sx={{
      mb: 1.25,
      p: 1,
      borderRadius: 1,
      backgroundColor: "#eef4ff",
      border: "1px solid #c8d8f5",
      display: "flex",
      alignItems: "center",
      gap: 1,
    }}
  >
    <Chip
      label="Mobile"
      color="primary"
      size="small"
      sx={{ fontWeight: 600, fontSize: "0.7rem", height: 20 }}
    />
    <Typography variant="caption" sx={{ color: "#1d3a7a" }}>
      {page} — optimized for small screens. Rotate or use a wider device for the full layout.
    </Typography>
  </Box>
);

export default MobileNotice;
